// Iter101 γ-3-I — AI intake (SITREP) API helpers.
//
// Multi-turn chat to extract a Freight Deal's main parameters, then
// create the draft via /create. The frontend keeps the transcript in
// component state and sends the whole `messages` array on each turn —
// the engine is stateless server-side (Mongo logs every call for
// admin-side observability but the chat history is owned by the client).
import axios from "axios";
import { useMutation, useQuery } from "@tanstack/react-query";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/ai-intake`;

export const useAiIntakeIntro = (context, locale = "en") =>
  useQuery({
    queryKey: ["ai-intake-intro", context, locale],
    queryFn: () => axios.get(`${API}/${context}/intro`, { params: { locale } }).then((r) => r.data),
    enabled: !!context,
  });

export const useAiIntakeChat = (context) =>
  useMutation({
    mutationFn: (body) =>
      axios.post(`${API}/${context}/chat`, body).then((r) => r.data),
  });

export const useAiIntakeCreate = (context) =>
  useMutation({
    mutationFn: (extracted) =>
      axios.post(`${API}/${context}/create`, { extracted }).then((r) => r.data),
  });

// Platform-admin observability — total / per user / per tenant / per day.
export const useAiUsageSummary = (days = 30) =>
  useQuery({
    queryKey: ["ai-usage-summary", days],
    queryFn: () =>
      axios.get(`${API}/usage/summary`, { params: { days } }).then((r) => r.data),
  });
